/**
 * Types et constantes de présentation des 5 dimensions d'impact.
 *
 * Pourquoi ce fichier existe séparément de `impact-scoring.ts` : ce dernier
 * importe `project-scores.json` (1 Mo, les scores des 423 projets). En ESM les
 * imports sont hoistés, donc un composant navigateur qui ne voulait que
 * `DIMENSION_COLORS` — deux douzaines d'octets de couleurs — embarquait le
 * catalogue entier dans son paquet (audit performance A1, 20 septembre 2026).
 *
 * Ici : aucune donnée, aucun import. À utiliser depuis les composants
 * `'use client'`. Le calcul des scores, lui, reste côté serveur.
 *
 * `impact-scoring.ts` réexporte ces symboles pour ne pas casser les appelants
 * existants — mais importer depuis `impact-scoring` rapatrie le JSON.
 */

export interface ImpactScores {
  climat: number
  biodiversite: number
  eau: number
  sols: number
  socioEco: number
}

export interface ImpactScoreResult {
  scores: ImpactScores
  average: number
  /** Dimensions with highest scores */
  highlights: (keyof ImpactScores)[]
  /** Radar chart data (ordered for pentagonal display) */
  radarData: { label: string; labelEn: string; key: keyof ImpactScores; value: number }[]
}

/** SVG colors for each dimension */
export const DIMENSION_COLORS: Record<keyof ImpactScores, string> = {
  climat: '#3F7E44',
  biodiversite: '#56C02B',
  eau: '#4A90A4',
  sols: '#8B6914',
  socioEco: '#D4A24C',
}

/** Clés de pictogrammes (voir src/components/Pictogram.tsx) pour chaque dimension */
export const DIMENSION_ICONS: Record<keyof ImpactScores, string> = {
  climat: 'globe',
  biodiversite: 'butterfly',
  eau: 'droplets',
  sols: 'sprout',
  socioEco: 'handshake',
}
